module.exports = __webpack_public_path__ + "img/2.3fdb55e0.jpg";